import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { iosAppUrlSelector, androidAppUrlSelector } from 'settings/selectors'

import AppStore from '../../icons/ic-appstore.svg'
import GooglePlay from '../../icons/ic-googleplay.svg'

import { appStoreBadgeUrlSelector, googlePlayBadgeUrlSelector } from '../../../wordpress/selectors'

const Badge = (defaultBadge, defaultAlt) => {
    const component = ({ containerClass, linkClass, imgClass, downloadUrl, badge, children, alt }) => {
        const Image = () => <img className={imgClass} src={badge || defaultBadge} alt={alt || defaultAlt} />
        return (
            <a href={downloadUrl} className={linkClass} target="_blank" rel="noopener noreferrer">
                {children ? (
                    <div className={containerClass}>
                        {children}
                        <Image />
                    </div>
                ) : (
                    <Image />
                )}
            </a>
        )
    }

    return component
}

export const AppStoreBadge = connect(
    createStructuredSelector({
        downloadUrl: iosAppUrlSelector,
        badge: appStoreBadgeUrlSelector,
    })
)(Badge(AppStore, 'Download on the App Store'))

export const GooglePlayStoreBadge = connect(
    createStructuredSelector({
        downloadUrl: androidAppUrlSelector,
        badge: googlePlayBadgeUrlSelector,
    })
)(Badge(GooglePlay, 'Get it on Google Play'))
